import styled from 'styled-components';
import tw from 'twin.macro';
// import MEDIA from '../../helpers/mediaTemplates';

export const Container = styled.div`
  ${tw`flex flex-wrap overflow-hidden w-full justify-center`}
  /* ${tw`justify-center`} */
`;
